import { render, staticRenderFns } from "./LeadComments.vue?vue&type=template&id=118d0504"
import script from "./LeadComments.vue?vue&type=script&lang=js"
export * from "./LeadComments.vue?vue&type=script&lang=js"
import style0 from "./LeadComments.vue?vue&type=style&index=0&id=118d0504&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports